(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/bet-modes/xpert-mode.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/bet-modes/xpert-mode.js');

'use strict';

const {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState
} = React;
const {
  fetchXpert,
  utils: {
    pixToCoupon
  }
} = svs.racing.raceService;
const {
  XpertPicker,
  BetslipXpertMode
} = svs.racing_game.components.play;
const {
  marketplace,
  Dialog,
  racing: {
    wager
  }
} = svs.components;
const XpertSummary = svs.racing.xpertSummary.XpertSummary;
const PlayContext = svs.racing_game.components.playContext.PlayContext;
const {
  getCancelledParticipants
} = svs.racing.common.util;
const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_MD
} = svs.components.lbUtils.useMediaQuery;
const {
  useNavigationActions
} = svs.racing.navigation;
const scrollToTop = () => {
  if (svs.core.detect.formfactor.mobile()) {
    document.querySelector('html, body').scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } else {
    document.querySelector('.left-column').scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
};
const XpertMode = _ref => {
  var _engine$xpert;
  let {
    isDisabled
  } = _ref;
  const {
    engine,
    race
  } = useContext(PlayContext);
  const systemType = useMemo(() => engine ? engine.systemType : undefined, [engine]);
  const gameType = useMemo(() => engine ? engine.gameType : undefined, [engine]);
  const {
    toRaceWithRow
  } = useNavigationActions();
  const numActiveParticipants = useMemo(() => race && race.participants ? race.numberOfParticipants - getCancelledParticipants(race.participants).length : 0, [race]);
  const pixValues = engine !== null && engine !== void 0 && engine.isReady && engine !== null && engine !== void 0 && (_engine$xpert = engine.xpert) !== null && _engine$xpert !== void 0 && _engine$xpert.data ? engine.xpert.data : [];
  const drawNumber = useMemo(() => engine && engine.selectors.getMeta().drawNumber ? engine.selectors.getMeta().drawNumber : undefined, [engine]);
  const [selectedSystemSize, setselectedSystemSize] = useState(svs.components.Storage.browser.get("systemsize_".concat(drawNumber), 'xpertmode'));
  const [pixData, setPixData] = useState(svs.components.Storage.browser.get("pix".concat(drawNumber), 'xpertmode'));
  const xpertPickerMultiline = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const more = pixValues.length > 9;
  const abortedPayment = svs.events.subscribe('/wager/paymentAborted', () => {
    clearStoredPix();
  });
  const cancelledPayment = svs.events.subscribe('/payment/cancel', () => {
    clearStoredPix();
  });
  const storePix = () => {
    if (!isSelfService) {
      svs.components.Storage.browser.set("pix".concat(drawNumber), 'xpertmode', pixData, undefined);
      svs.components.Storage.browser.set("systemsize_".concat(drawNumber), 'xpertmode', selectedSystemSize, undefined);
    }
  };
  const clearStoredPix = () => {
    svs.components.Storage.browser.remove("pix".concat(drawNumber), 'xpertmode');
    svs.components.Storage.browser.remove("systemsize_".concat(drawNumber), 'xpertmode');
    svs.events.unsubscribe(abortedPayment);
    svs.events.unsubscribe(cancelledPayment);
  };
  const getCurrentAmount = () => {
    const data = pixValues.filter(value => value.systemSize === selectedSystemSize);
    if (data && data[0]) {
      return data[0].amount;
    }
    return 0;
  };
  const payPIX = () => {
    const totalAmount = getCurrentAmount();
    const rowAmount = totalAmount / selectedSystemSize;
    storePix();
    wager.createWager(engine, totalAmount, rowAmount, drawNumber, race, () => {
      setPixData(undefined);
      setselectedSystemSize(0);
      clearStoredPix();
      scrollToTop();
    }, toRaceWithRow, {
      isRetailerAdmin: svs.racing_game.data.isRetailerAdmin,
      marketplace
    });
  };
  useEffect(() => {
    engine.actions.clearAll();
    if (pixData) {
      engine.actions.trySetData(pixToCoupon(engine.systemType, pixData, selectedSystemSize, race.numberOfParticipants));
    }
  }, [pixData]);
  const getPix = useCallback(() => {
    if (!selectedSystemSize || !drawNumber) {
      return;
    }
    fetchXpert(drawNumber, selectedSystemSize, (err, pixWager) => {
      let dialog;
      if (err) {
        dialog = new Dialog.Confirm({
          actions: [{
            title: 'Ok',
            callback: () => {
              dialog.close();
            }
          }],
          area: svs.components.dialog.area.POPUP,
          branding: svs.components.dialog.branding.SPORT,
          icon: 'target',
          message: [{
            type: svs.components.dialog.message.TEXT,
            text: err.message,
            align: svs.components.dialog.message.align.CENTER
          }],
          product: 'Racing',
          title: 'Fel',
          type: svs.components.dialog.type.ERROR
        });
        Dialog.api.add(dialog);
      } else {
        setPixData(pixWager);
      }
    });
  }, [drawNumber, selectedSystemSize]);
  useEffect(() => {
    if (engine.isReady && !svs.components.Storage.browser.get("pix".concat(drawNumber), 'xpertmode')) {
      getPix();
    }
    clearStoredPix();
  }, [engine.isReady, getPix, selectedSystemSize]);
  if (!engine.isReady) {
    return null;
  }
  return React.createElement("div", {
    className: selectedSystemSize ? 'xpert-mode-holder' : 'padding-xs-bottom-4 xpert-mode-holder'
  }, React.createElement("div", {
    className: "picker-header"
  }, React.createElement("span", null, "V\xE4lj insats")), React.createElement("div", {
    className: "xpert-mode"
  }, React.createElement(XpertPicker, {
    isMultipleLines: more ? true : xpertPickerMultiline,
    numActiveParticipants: numActiveParticipants,
    selectedSystemSize: selectedSystemSize,
    setSelectedSystemSize: setselectedSystemSize,
    xpertData: pixValues
  }), pixData && React.createElement(React.Fragment, null, React.createElement(XpertSummary, {
    betAmount: getCurrentAmount(),
    gameType: gameType,
    nrOfRows: selectedSystemSize,
    positions: pixData.row,
    reload: getPix,
    reserve: engine.selectors.getReserve() + 1,
    systemType: systemType
  }), React.createElement(BetslipXpertMode, {
    getMeta: engine.selectors.getMeta,
    handlePayBtnClick: payPIX,
    isDisabled: isDisabled,
    selectedAmount: getCurrentAmount()
  }))));
};
svs.racing_game.components.play.XpertMode = XpertMode;

 })(window);